import { render, staticRenderFns } from "./AddDocumentRequest.vue?vue&type=template&id=21d20009&scoped=true"
import script from "./AddDocumentRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./AddDocumentRequest.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddDocumentRequest.vue?vue&type=style&index=0&id=21d20009&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d20009",
  null
  
)

export default component.exports